export default "__VITE_ASSET__DHxW_AKS__"